import { SectionHeaderTitleAs } from '../../SectionHeader';

export interface SectionProps {
  title?: React.ReactNode;
  titleVisible?: boolean;
  suffix?: React.ReactElement;
  children?: React.ReactNode;
  ariaLabel?: string;
  dataHook?: string;
  as?: SectionHeaderTitleAs;
  id?: string;
  'aria-describedby'?: string;
}
